export const ADJUST_TRANSACTION = 'ADJUST_TRANSACTION';
export const WRITE_OFF_TRANSACTION = 'WRITE_OFF_TRANSACTION';
export const MANUAL_TRANSACTION = 'MANUAL_TRANSACTION';
export const INVALID_TRANSACTION = 'INVALID_EXCEPTION';
export const EXCLUDE_TRANSACTION = 'EXCLUDE_TRANSACTION';
